export interface TurfBasketState {
  basketItemIds: string[];
  pinnedItemIds: string[];
}

export const TURF_BASKET_STATES = {
  BEST_SET: 'bestSet',
  CUSTOM: 'custom',
} as const;

export const TURF_BASKET_STATE_PARAMS = {
  BEST_SET: 'best_set',
  CUSTOM: 'custom',
} as const;

export type TurfBasketStateValue = (typeof TURF_BASKET_STATES)[keyof typeof TURF_BASKET_STATES];

export const clearBasketState = (): TurfBasketState => ({
  basketItemIds: [],
  pinnedItemIds: [],
});

export const getBasketStateFromParam = (value: null | string): TurfBasketStateValue =>
  value === TURF_BASKET_STATE_PARAMS.BEST_SET
    ? TURF_BASKET_STATES.BEST_SET
    : TURF_BASKET_STATES.CUSTOM;

export const getBasketStateParam = (basketState: TurfBasketStateValue): string =>
  basketState === TURF_BASKET_STATES.BEST_SET
    ? TURF_BASKET_STATE_PARAMS.BEST_SET
    : TURF_BASKET_STATE_PARAMS.CUSTOM;

export const toggleBasketItem = ({
  basketItemIds,
  itemId,
  pinnedItemIds,
}: TurfBasketState & { itemId: string }): TurfBasketState => {
  if (pinnedItemIds.includes(itemId)) {
    return { basketItemIds, pinnedItemIds };
  }

  return {
    basketItemIds: basketItemIds.includes(itemId)
      ? basketItemIds.filter((selectedItemId) => selectedItemId !== itemId)
      : [...basketItemIds, itemId],
    pinnedItemIds,
  };
};

export const togglePinnedItem = ({
  basketItemIds,
  itemId,
  pinnedItemIds,
}: TurfBasketState & { itemId: string }): TurfBasketState => {
  if (pinnedItemIds.includes(itemId)) {
    return {
      basketItemIds,
      pinnedItemIds: pinnedItemIds.filter((pinnedItemId) => pinnedItemId !== itemId),
    };
  }

  return {
    basketItemIds: basketItemIds.includes(itemId) ? basketItemIds : [...basketItemIds, itemId],
    pinnedItemIds: [...pinnedItemIds, itemId],
  };
};
